import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@wds/modal';
import { Button } from '@wds/button';
import { Box } from '@wds/box';
import { IconArrowLeft, IconArrowRight } from '@wds/icons';
import ResponsiveImage from './components/ResponsiveImage';
import useStyles from './styles';

function* nextInArray(array, startIndex = 0, reverse = false) {
  let index = startIndex;
  const step = reverse ? -1 : 1;

  while (true) {
    yield array[index];
    index = (index + step + array.length) % array.length;
  }
}

const AppDetailsMedia = ({ mediaFiles = [{}], mediaIndex = 0, maxHeight }) => {
  const media = mediaFiles[mediaIndex];
  const {
    appDetailsMediaModalImg,
    appDetailsMediaModalYoutube,
    appDetailsYoutubeWrapper,
    appDetailsYoutubeFrame,
    appDetailsMediaModalYoutubeWrapper,
    appDetailsModalLeft,
    appDetailsModalMain,
    appDetailsModalRight,
  } = useStyles();
  const [showModal, setShowModal] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(mediaFiles[mediaIndex]);
  const [nextMediaGenerator, setNextImageGenerator] = useState(null);
  const [prevMediaGenerator, setPrevImageGenerator] = useState(null);

  useEffect(() => {
    setNextImageGenerator(nextInArray(mediaFiles, mediaIndex, false));
    setPrevImageGenerator(nextInArray(mediaFiles, mediaIndex, true));
  }, [mediaFiles, mediaIndex]);

  const previousMedia = () => {
    setSelectedMedia(prevMediaGenerator.next().value);
  };

  const nextMedia = () => {
    setSelectedMedia(nextMediaGenerator.next().value);
  };

  return (
    <Choose>
      <When condition={media.type === 'youtube'}>
        <div className={appDetailsYoutubeWrapper}>
          <iframe
            className={appDetailsYoutubeFrame}
            data-testid="AppDetailsMedia__SelectedVideo"
            allowFullScreen
            src={media.url}
            title={media.altText}
          />
        </div>
      </When>
      <Otherwise>
        <div>
          <Box onClick={() => setShowModal(true)} display="grid" placeItems="center">
            <ResponsiveImage alt={selectedMedia.altText} src={selectedMedia.url} maxHeight={maxHeight || 'auto'} />
          </Box>
          <Modal show={showModal} size="xl" onClose={() => setShowModal(false)} closeButtonLabel="Close Image">
            <Modal.Body>
              <Box display="grid" gridTemplateColumns="68px auto 68px">
                <Box className={appDetailsModalLeft}>
                  <Button aria-label="Previous Screenshot" color="secondary" onClick={previousMedia} variant="text">
                    <IconArrowLeft size="xl" />
                  </Button>
                </Box>
                <Box className={appDetailsModalMain} px={3}>
                  <If condition={selectedMedia.type === 'youtube'}>
                    <Box className={appDetailsMediaModalYoutube}>
                      <Box className={appDetailsMediaModalYoutubeWrapper}>
                        <iframe
                          className={appDetailsYoutubeFrame}
                          data-testid="AppDetailsMedia__SelectedVideo"
                          allowFullScreen
                          src={selectedMedia.url}
                          title={selectedMedia.altText}
                        />
                      </Box>
                    </Box>
                  </If>
                  <If condition={selectedMedia.type !== 'youtube'}>
                    <Box display="grid" placeItems="center">
                      <img
                        alt={selectedMedia.altText}
                        data-testid="AppDetailsMedia__SelectedImage"
                        className={appDetailsMediaModalImg}
                        height="auto"
                        src={selectedMedia.url}
                      />
                    </Box>
                  </If>
                </Box>
                <Box className={appDetailsModalRight}>
                  <Button aria-label="Next Screenshot" color="secondary" onClick={nextMedia} variant="text">
                    <IconArrowRight size="xl" />
                  </Button>
                </Box>
              </Box>
            </Modal.Body>
          </Modal>
        </div>
      </Otherwise>
    </Choose>
  );
};

AppDetailsMedia.propTypes = {
  mediaFiles: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      url: PropTypes.string,
      altText: PropTypes.string,
    })
  ).isRequired,
  mediaIndex: PropTypes.number.isRequired,
  maxHeight: PropTypes.number,
};

AppDetailsMedia.defaultProps = {
  maxHeight: null,
};

export default AppDetailsMedia;
